import { controlCharsObject } from "@quickpoint.me/shared";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";

import { CurrentFilter } from "../state/filter";
import { PageIndex, StickyFooterElementsToDisplay } from "../state/page";

import { useLayoutEffect } from "react";
import mapPageCode, { type MapPageCodeArgs } from "../lib/mapPageCode";
import { NeueroDivergentReader } from "../state/accessibility";
import {
	AudioFileMaps,
	DataFileMaps,
	ImageMaps,
	ParsedCode,
} from "../state/selectors";
import { EditMode, ShowAllTapElements } from "../state/ui";

function FindStickyFooter() {
	const currentFilter = useRecoilValue(CurrentFilter);
	const editMode = useRecoilValue(EditMode);
	// render the incoming page in advance
	const pageIndex = useRecoilValue(PageIndex);
	const parsedCode = useRecoilValue(ParsedCode);
	const imageMaps = useRecoilValue(ImageMaps);
	const dataFileMaps = useRecoilValue(DataFileMaps);
	const audioFileMaps = useRecoilValue(AudioFileMaps);

	const neueroDivergentReader = useRecoilValue(NeueroDivergentReader);
	const showAllTapElements = useRecoilValue(ShowAllTapElements(pageIndex));
	const setStickyElements = useSetRecoilState(StickyFooterElementsToDisplay);
	const resetStickyElements = useResetRecoilState(
		StickyFooterElementsToDisplay,
	);

	useLayoutEffect(() => {
		let menuOnPages: number[] = [];
		for (let idx = 0; idx < parsedCode.length; idx++) {
			const page = parsedCode[idx];
			for (const line of page) {
				if (line.type === controlCharsObject["vvv"].controlChar) {
					menuOnPages.push(idx + 1); // use the page  number
				}
			}
		}
		const unique = new Set(menuOnPages);
		menuOnPages = Array.from(unique).sort((a, b) => a - b);

		// a) no sticky-footer exists anywhere in the document
		if (menuOnPages.length === 0) {
			resetStickyElements();             // clear any previous footer
			return;                            // stop – nothing to render
		}

		// b) reader has not reached the first sticky-footer page yet
		if (pageIndex < menuOnPages[0]) {
			resetStickyElements();             // hide footer until we arrive there
			return;
		}

		let menuToRender =
			menuOnPages.filter((p) => p <= pageIndex).pop() ?? menuOnPages[0];

		const pageArgs: MapPageCodeArgs = {
			pageCode: parsedCode[menuToRender - 1], // parsed code is base 0
			showAllTapElements,
			editMode,
			imageMaps,
			dataFileMaps,
			audioFileMaps,
			currentFilter,
			neueroDivergentReader,
			pageIndex: menuToRender,
		};

		const { stickyFooterReactElements } = mapPageCode(pageArgs);
		setStickyElements(stickyFooterReactElements);

		return resetStickyElements;
	}, [
		pageIndex,
		currentFilter,
		editMode,
		parsedCode,
		imageMaps,
		dataFileMaps,
		audioFileMaps,
		neueroDivergentReader,
		showAllTapElements,
		setStickyElements,
		resetStickyElements,
	]);

	return <></>;
}

export default FindStickyFooter;
